export default __webpack_public_path__ + "static/media/gallery_06.5d41ee68.jpg";